import { isCustomView } from '../list/isCustomView';
import { DEFAULT_MENU_ITEM, findEntry } from './buildMenu';
import type { IMenuSection } from './IMenuSection';
import { libraryModeOf } from './libraryModes';

/** Ключ пункту таблиці «Усі …» у меню (buildMenu): пункт подання `view:table`, якщо він є, інакше типовий DEFAULT_MENU_ITEM. */
const TABLE_ITEM = 'view:table';

/**
 * Ключ активного пункту меню типу `rtKey` за маршрутом (`rt`, `id`, `view`), пунктом `item` (`?item=`) і режимом `mode` (`?mode=`): лише на
 * сторінці списку цього типу (не на сторінці запису); той самий пункт, що відкриває список, — `item` або, без нього, типовий «Усі …»
 * (`view:table` чи DEFAULT_MENU_ITEM). Пункт подання активний, лише поки відкрите його подання (прототип v4: «Усі записи» — на таблиці, не на
 * картках), пункт бібліотеки — ще й у своєму режимі. Власне подання без пункту меню («Бібліотека» та її режими — власні пункти меню) жодного
 * пункту не підсвічує. Інакше null. Чиста функція.
 */
export function activeEntryKey(
  rtKey: string, sections: IMenuSection[], route: { rt?: string; id?: string; view?: string }, item: string | null, mode: string | null,
): string | null {
  if (route.rt !== rtKey || route.id) return null;
  if (route.view && isCustomView(route.view) && !item) return null;
  const hasTable = sections.some((s) => s.entries.some((e) => e.key === TABLE_ITEM));
  const key = item ?? findEntry(sections, hasTable ? TABLE_ITEM : DEFAULT_MENU_ITEM).key;
  const entry = sections.flatMap((s) => s.entries).find((e) => e.key === key);
  if (entry?.view && route.view && entry.view !== route.view) return null;
  if (entry?.mode && entry.mode !== libraryModeOf(mode)) return null;
  return key;
}
